import CopyBlock from './copy-block';
export default CopyBlock;